(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ReleaseNotesController', ReleaseNotesController);

    ReleaseNotesController.$inject = ['$scope','$state','ParseLinks','AlertService','ToastrService'];

    function ReleaseNotesController ($scope, $state, ParseLinks, AlertService, ToastrService) {
        var vm = this;

    }
})();
